var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'megamenu',
        {'megamenu--departments': _vm.location === 'departments'}
    ]},[_c('div',{staticClass:"megamenu__body",style:(_vm.bodyStyles)},[_c('div',{staticClass:"row"},_vm._l((_vm.menu.columns),function(column,index){return _c('div',{key:index,class:`col-${column.size}`},[_c('MegamenuLinks',{attrs:{"links":column.links}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }